import { createAction } from "@reduxjs/toolkit";
import { put, select, take, takeEvery } from "redux-saga/effects";

import { getPostById } from "api/post";
import { openEditPostModal, Post } from "features/post";
import isEmpty from "lodash/isEmpty";
import { toast } from "react-toastify";
import { entitlementFeatureToggle } from "../../utils/feature-toggle-utils";
import {
  LoadedDraft,
  normalizeAnyPost,
} from "../../selectors/loaded-posts-normalizer";
import { openEditPostModalV2 } from "../post/bulk-create/bulk-create-post.actions";

export const opedPostModalById = createAction<{ postId: string }>(
  "opedPostModalById"
);

function* openPostById({ payload: { postId } }) {
  try {
    const post = yield getPostById(postId);
    yield waitFor((state) => state.user);
    if (entitlementFeatureToggle.get("bulk-create")) {
      const editPost: Post | LoadedDraft = yield normalizeAnyPost(post);
      yield put(openEditPostModalV2({ post: editPost }));
    } else {
      yield put(openEditPostModal({ post }));
    }
  } catch (e) {
    console.error(e);
    // most common case - post is no longer a draft or has been deleted etc
    if (e?.response?.status === 404) {
      toast.error(
        `Sorry, the post or draft with ID ${postId} could not be found. It has been moved or deleted.`
      );
    } else if (e?.response?.data?.message) {
      // in case we return a
      toast.error(
        `Sorry, the post or draft with ID ${postId} could not be loaded. ${e.response.data.message}`
      );
    } else {
      toast.error(
        `Sorry, the post or draft with ID ${postId} could not be loaded.`
      );
    }
  }
}

export function* deepLinkPostSaga() {
  yield takeEvery(opedPostModalById.type, openPostById);
}

export function* waitFor(selector) {
  const data = yield select(selector);
  if (!isEmpty(data)) {
    return;
  }
  yield take("*");
  yield waitFor(selector);
}
